import React from 'react';

// Comparison table: a table from 640px, stacked cards below (one card per
// row, each value labelled with its column). Reusable in pages and MDX.
//
// columns: [{ label, highlight? }]. The first column labels the rows; a
//   column with highlight: true gets a navy header and tinted cells.
// rows: [{ label, emphasis?, cells: [{ icon?, text }] }], one cell per
//   column after the first. icon: 'yes' (✓ green), 'no' (✕ red) or
//   'varies' (~ amber); the text carries the meaning, the icon is decoration.
// footer: optional node, shown under the table.
// caption: optional accessible name for the table.

const ICONS = { yes: '✓', no: '✕', varies: '~' };

const Cell = ({ cell }) => (
  <>
    {cell.icon && <span className={`ct-icon ct-icon-${cell.icon}`} aria-hidden="true">{ICONS[cell.icon]}</span>}
    <span>{cell.text}</span>
  </>
);

const ComparisonTable = ({ columns, rows, footer, caption }) => {
  const [rowHead, ...valueCols] = columns;
  return (
    <div className="ct">
      <table>
        {caption && <caption className="ct-caption">{caption}</caption>}
        <thead>
          <tr>
            <th scope="col">{rowHead.label}</th>
            {valueCols.map((c) => (
              <th key={c.label} scope="col" className={c.highlight ? 'ct-hl' : undefined}>{c.label}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.label} className={r.emphasis ? 'ct-emphasis' : undefined}>
              <th scope="row">{r.label}</th>
              {r.cells.map((cell, i) => (
                <td key={valueCols[i].label} className={valueCols[i].highlight ? 'ct-hl' : undefined}>
                  <span className="ct-col">{valueCols[i].label}: </span>
                  <span className="ct-value"><Cell cell={cell} /></span>
                </td>
              ))}
            </tr>
          ))}
        </tbody>
        {footer && (
          <tfoot>
            <tr><td colSpan={columns.length}>{footer}</td></tr>
          </tfoot>
        )}
      </table>
    </div>
  );
};

export default ComparisonTable;
